import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Container, Form } from "react-bootstrap";
import CustomFormCheck from "utils/CustomFormCheck";
import CustomTooltip from "utils/CustomTooltip";
import BackButton from "./BackButton";
import NextButton from "./NextButton";
import SkipButton from "./SkipButton";
import getNextPage from "./getNextPage";
import { RouterContext } from "./Onboarding";
import jsDig from "utils/jsDig";
import DataPullSavePopUp from "../utils/DataPullSavePopUp";

export default function SeoDataPull(props) {
  const route = useContext(RouterContext);
  const [validated, setValidation] = useState(false);

  const nextPage = getNextPage(props.onboarding_progress);
  useEffect(() => {
    window.localStorage.setItem("routerHistory", JSON.stringify([...route.get]));
  }, [route.get]);
  props.pageLocator();

  const seoPullboxes = props.pullBoxes.slice(2, 5);

  const pullResetter = () => {
    return props.pullBoxes
      .filter(
        (platform, idx) =>
          platform[0] == "Google: SEO" ||
          platform[0] == "Google Search Console" ||
          platform[0] == "SEMRush" ||
          (platform[0] == "Shopify" && jsDig(["website_platform"], props.client_account) != "0")
      )
      .map((newItem) => {
        newItem[2] = false;
        return newItem;
      });
  };

  const pullUpdateHelper = (idx, newValue) => {
    let newArray = props.pullBoxes;
    newArray[idx][2] = newValue;
    props.setPullBoxes((prevState) => [...newArray]);
  };
  const [showBoxes, setShowBoxes] = useState(false);
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Container fluid className="px-lg-5 px-0">
      <Row className="px-lg-4 px-0 mb-3 pb-3 justify-content-center">
        <Col md={10}>
          <Row className="mb-1 justify-content-center">
            <Col md={9}>
              <div>
                <p className="pb-3 f28 visby-bold primary text-center">Pull SEO Data</p>
              </div>
              <div>
                <p className="f16 nunito-regular  primary ">Would you like to pull data from your accounts now?</p>
              </div>
            </Col>
          </Row>
          <input hidden name="current_onboarding_page" value={window.location.href} readOnly />
          <Row className="mb-3 pb-3 justify-content-center">
            <Col md={9}>
              <div className="pb-1 pt-2">
                <CustomTooltip
                  faClass="far fa-question-circle pb-1 f16 text-info pt-1 pr-2"
                  message={"Would you like to start pulling data from other platforms?"}
                  inline={true}
                />{" "}
                <span className=" f16 text-info ">What does this mean?</span>
              </div>
              <div className="d-flex flex-column ">
                <Form.Check
                  className="f16"
                  name="ob-pull-data"
                  custom
                  label="Yes I would like to pull data now."
                  type="radio"
                  id="ob-yes-pull"
                  onClick={() => {
                    setShowBoxes(true), setValidation(false);
                  }}
                />
                <Form.Check
                  name="ob-pull-data"
                  className="f16"
                  custom
                  label="No, do not pull data."
                  type="radio"
                  id="ob-no-pull"
                  onClick={() => {
                    setShowBoxes(false), setValidation(true), pullResetter();
                  }}
                />
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <div className={showBoxes === false ? "d-none" : undefined}>
        <Row className="justify-content-center">
          <Col md={7}>
            <p className="f16 mb-4">For which accounts?</p>
            <div className="my-3 platform-list">
              {props.pullBoxes.map((platform, idx) => {
                let show = false;
                if (
                  (platform[0] == "Google: SEO" && Object.values(jsDig(["Google Analytics"], props.client_account.team_access)).includes("1")) ||
                  (platform[0] == "Google Search Console" && Object.values(jsDig(["Google Search Console"], props.client_account.team_access)).includes("1")) ||
                  (platform[0] == "SEMRush" && Object.values(jsDig(["SEMRush"], props.client_account.team_access)).includes("1"))
                ) {
                  show = true;
                }
                const visible = show ? "flex " : "none";
                return (
                  <div key={platform[0]} className=" pb-2 justify-content-start" style={{ display: visible }}>
                    <CustomFormCheck
                      id={`ob-${platform[0]}`}
                      name={`[pull_platform_data]${platform[1]}`}
                      label={platform[0]}
                      checked={platform[2]}
                      onChange={(e) => {
                        pullUpdateHelper(idx, !platform[2]);
                        if (show) {
                          let exist = seoPullboxes.find((el) => el.includes(true));
                          if (exist == undefined) setValidation(false);
                          else setValidation(true);
                        }
                      }}
                    />
                  </div>
                );
              })}
            </div>
            <p className="font-weight-bold text-danger">Clicking next will initiate a large data pull which could take several hours to complete.</p>
          </Col>
        </Row>
      </div>
      <Row className="mt-5 ">
        <Col>
          <div className="navButtonRow">
            <BackButton />
            <SkipButton btnText={`Skip for now`} nextPage={nextPage.url} />
            <NextButton
              validated={validated}
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={() => {
                showBoxes ? setOpen(true) : props.submitForm(nextPage.url);
                // props.manualDataPull();
                // props.submitForm(nextPage.url);
              }}
            />
            <DataPullSavePopUp
              manualDataPull={props.manualDataPull}
              submitForm={() => props.submitForm(nextPage.url)}
              open={open}
              handleClose={handleClose}
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
}
